var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_66",
    "data-name": "Groupe 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 6.289,
    height: 10,
    viewBox: "0 0 6.289 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 6.289,
    height: 10,
    fill: "#0f0a53"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_64",
    "data-name": "Groupe 64",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M.278,4.377Q2.26,2.4,4.237.423a1.281,1.281,0,0,1,.412-.3A1.129,1.129,0,0,1,6.005,1.877a1.178,1.178,0,0,1-.088.1L2.976,4.911c-.026.026-.051.053-.086.09.038.032.069.055.1.082Q4.455,6.552,5.924,8.021a1.036,1.036,0,0,1,.137.17A1.129,1.129,0,0,1,4.494,9.782a.963.963,0,0,1-.169-.132Q2.292,7.625.265,5.594a.921.921,0,0,1-.215-.334.8.8,0,0,1,.228-.882",
    transform: "translate(0)",
    fill: "#0f0a53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e3d0a4243ebaceaf30b523e634da1ad5.svg";
export { ForwardRef as ReactComponent };